// cart count update js
document.addEventListener('DOMContentLoaded', function () {
  // Function to update cart item count
  function updateCartItemCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCountElement = document.querySelector('.cart-count b');
        if (itemCountElement) {
          const label = cart.item_count === 1 ? 'item' : 'items';
          itemCountElement.textContent = `${cart.item_count} ${label}`;
        }

        const cartLinkBubble = document.querySelector(".cart-link__bubble");

        // Inject CSS based on cart state
        if (cart.item_count === 0) {
          addEmptyCartCSS();
          if (cartLinkBubble) {
            cartLinkBubble.classList.remove("cart-link__bubble--visible");
          }
        } else {
          removeEmptyCartCSS();
          if (cartLinkBubble) {
            cartLinkBubble.classList.add("cart-link__bubble--visible");
          }
        }
      });
  }

  // Add CSS dynamically
  function addEmptyCartCSS() {
    let styleTag = document.getElementById('empty-cart-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'empty-cart-style';
      styleTag.textContent = `
        .custom-cart { display: block; }
        #convx-style-by-us .convx-style-by-us { display: none; }
      `;
      document.head.appendChild(styleTag);
    }
  }

  // Remove CSS if not needed
  function removeEmptyCartCSS() {
    const styleTag = document.getElementById('empty-cart-style');
    if (styleTag) {
      styleTag.remove();
    }

    // Add style to show the convx-style-by-us elements when cart is not empty
    let nonEmptyStyleTag = document.getElementById('non-empty-cart-style');
    if (!nonEmptyStyleTag) {
      nonEmptyStyleTag = document.createElement('style');
      nonEmptyStyleTag.id = 'non-empty-cart-style';
      nonEmptyStyleTag.textContent = `
        #convx-style-by-us .convx-style-by-us { display: block; }
      `;
      document.head.appendChild(nonEmptyStyleTag);
    }
  }

  // Monitor changes in the cart
  function monitorCartUpdates() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch(...args).then((response) => {
        // Check if the request is a cart update
        if (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
          updateCartItemCount();
        }
        if (args[0].includes('/cart/add') && window.theme.cartPageForm) {
          window.theme.cartPageForm.buildCart();
        }
        return response;
      });
    };
  }

  // Initialize monitoring and update count on load
  monitorCartUpdates();
  updateCartItemCount();
});



// Reload Page When Cart Becomes Empty
document.addEventListener("DOMContentLoaded", function () {
  // Function to check if the cart is empty and reload
  function checkCartAndReloadIfEmpty() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (cart.items.length === 0) {
          location.reload();
        }
      });
  }

  // Listen for clicks on quantity minus and plus buttons
  document.body.addEventListener("click", function (e) {
    const isMinusOrPlus = e.target.closest(".js-qty__adjust");
    if (isMinusOrPlus) {
      // Wait a bit for cart to be updated
      setTimeout(() => {
        checkCartAndReloadIfEmpty();
      }, 600); // Adjust if your Ajax update is slower
    }
  });

  // Also check if quantity field is manually changed and blurred
  document.querySelectorAll(".js-qty__num").forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(() => {
        checkCartAndReloadIfEmpty();
      }, 600);
    });
  });
});


// variant selector cart page and drawer
// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll(".variant-selector").forEach(function(selectEl) {
//     selectEl.addEventListener("change", function(e) {
//       e.preventDefault();

//       const newVariantId = parseInt(e.target.value, 10);
//       let lineKey = e.target.getAttribute("data-line-key");
//       const quantity = parseInt(e.target.getAttribute("data-original-quantity"), 10);

//       if (!newVariantId || !lineKey || !quantity) {
//         alert("Error: Missing variant or line item data.");
//         return;
//       }

//       // Remove old variant line
//       fetch("/cart/change.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", "Accept": "application/json" },
//         body: JSON.stringify({ id: lineKey, quantity: 0 })
//       })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to remove old variant");
//         return res.json();
//       })
//       .then(() => {
//         // Add new variant with same quantity
//         return fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", "Accept": "application/json" },
//           body: JSON.stringify({ id: newVariantId, quantity: quantity })
//         });
//       })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to add new variant");
//         return res.json();
//       })
//       .then(addedItem => {
//         // Fetch updated cart
//         return fetch("/cart.js", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", "Accept": "application/json" }
//         }).then(res => res.json())
//           .then(cart => ({ cart, addedItem }));
//       })
//       .then(({ cart, addedItem }) => {
//         // Find the line item key for the newly added variant (based on variant_id and quantity)
//         const newLineItem = cart.items.find(item => item.variant_id === addedItem.variant_id && item.quantity === quantity);

//         if (!newLineItem) {
//           throw new Error("Could not find updated line item");
//         }

//         // Update the dropdown's data-line-key attribute to new line item key
//         e.target.setAttribute("data-line-key", newLineItem.key);
//         e.target.setAttribute("data-original-quantity", newLineItem.quantity);

//         // Optional: update cart totals or UI here


//       })
//       .catch(error => {
//         console.error(error);

//       });
//     });
//   });
// });

// cart drawer open b0dy class js
// Global variable to store observer and prevent multiple instances
let cartObserver = null;
let isObserverActive = false;

// Function to toggle body class based on cart state
function setupCartObserver() {
  const cartElement = document.querySelector('.ast-cart');
  const body = document.body;

  if (!cartElement) {
    console.log('Cart element not found, retrying...');
    setTimeout(setupCartObserver, 500);
    return;
  }

  // If observer is already active, don't create another one
  if (isObserverActive) {
    console.log('Observer already active');
    return;
  }

  console.log('Setting up cart observer');

  // Disconnect existing observer if any
  if (cartObserver) {
    cartObserver.disconnect();
  }

  // Create a new MutationObserver
  cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;

        if (target.classList.contains('ast-open')) {
          body.classList.add('cart-is-open');
          console.log('Cart opened - added cart-is-open class to body');
        } else {
          body.classList.remove('cart-is-open');
          console.log('Cart closed - removed cart-is-open class from body');
        }
      }
    });
  });

  // Start observing
  cartObserver.observe(cartElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  isObserverActive = true;
  console.log('Cart observer is now active');

  // Check initial state
  if (cartElement.classList.contains('ast-open')) {
    body.classList.add('cart-is-open');
    console.log('Initial state: cart is open');
  }
}

// Alternative method: Use event delegation to catch cart toggle events
function setupEventDelegation() {
  console.log('Setting up event delegation fallback');

  // Listen for clicks that might trigger cart
  document.addEventListener('click', function (e) {
    // Common cart trigger selectors in Astra
    const cartTriggers = [
      '.ast-cart-menu-wrap',
      '.ast-cart-trigger',
      '.astra-cart-drawer-trigger',
      '[data-toggle-target*="ast-cart"]',
      '.ast-addon-cart-wrap'
    ];

    const isCartTrigger = cartTriggers.some(selector =>
      e.target.closest(selector)
    );

    if (isCartTrigger) {
      console.log('Cart trigger clicked');

      // Small delay to allow cart state to change
      setTimeout(function () {
        const cart = document.querySelector('.ast-cart');
        const body = document.body;

        if (cart) {
          if (cart.classList.contains('ast-open')) {
            body.classList.add('cart-is-open');
            console.log('Event delegation: Cart opened');
          } else {
            body.classList.remove('cart-is-open');
            console.log('Event delegation: Cart closed');
          }
        }
      }, 150);
    }
  });

  // Also listen for escape key to close cart
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setTimeout(function () {
        const cart = document.querySelector('.ast-cart');
        if (cart && !cart.classList.contains('ast-open')) {
          document.body.classList.remove('cart-is-open');
          console.log('Cart closed via Escape key');
        }
      }, 150);
    }
  });
}

// Initialize everything
function initCartBodyClass() {
  console.log('Initializing cart body class functionality');

  // Set up both methods for reliability
  setupCartObserver();
  setupEventDelegation();

  // Also set up a periodic check as fallback (every 2 seconds)
  setInterval(function () {
    const cart = document.querySelector('.ast-cart');
    const body = document.body;

    if (cart) {
      const shouldHaveClass = cart.classList.contains('ast-open');
      const currentlyHasClass = body.classList.contains('cart-is-open');

      if (shouldHaveClass && !currentlyHasClass) {
        body.classList.add('cart-is-open');
        console.log('Periodic check: Added cart-is-open class');
      } else if (!shouldHaveClass && currentlyHasClass) {
        body.classList.remove('cart-is-open');
        console.log('Periodic check: Removed cart-is-open class');
      }
    }
  }, 2000);
}

// Multiple initialization attempts
function startInitialization() {
  // Try immediately
  if (document.readyState === 'complete') {
    initCartBodyClass();
  } else if (document.readyState === 'interactive') {
    setTimeout(initCartBodyClass, 100);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initCartBodyClass, 100);
    });
  }

  // Also try after window load
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (!isObserverActive) {
        console.log('Retry initialization after window load');
        initCartBodyClass();
      }
    }, 500);
  });

  // jQuery fallback if available
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(function () {
      setTimeout(function () {
        if (!isObserverActive) {
          console.log('Retry initialization via jQuery');
          initCartBodyClass();
        }
      }, 200);
    });
  }
}

// Start the initialization process
startInitialization();

class ProductUpdater {
  constructor() {
    document.addEventListener("variant:change", this.onVariantChange.bind(this));
  }

  async onVariantChange(event) {
    if (!event.detail || !event.detail.variant) {
      console.warn("variant:change fired without variant", event);
      return;
    }

    const variantId = event.detail.variant.id;
    if (!variantId) return;

    const response = await fetch(
      window.location.pathname + '?variant=' + variantId
    );

    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    this.updateStockIndicator(doc);
    this.updateStockPrice(doc);
    this.updateStickySection(doc);
  }


  updateStickySection(doc) {
    // Update variant title in sticky info
    const oldTitle = document.querySelector('.titus-sticky-navbar span');
    const newTitle = doc.querySelector('.titus-sticky-navbar span');
    if (oldTitle && newTitle) oldTitle.textContent = newTitle.textContent;

    // Update hidden input in sticky form
    const oldInput = document.querySelector('.titus-sticky-navbar input[name="id"]');
    const newInput = doc.querySelector('.titus-sticky-navbar input[name="id"]');
    if (oldInput && newInput) oldInput.value = newInput.value;

    // Update button data-product-id
    const oldButton = document.querySelector('.titus-sticky-navbar .add-to-cart-button');
    const newButton = doc.querySelector('.titus-sticky-navbar .add-to-cart-button');
    if (oldButton && newButton) {
      oldButton.setAttribute('data-product-id', newButton.getAttribute('data-product-id'));
    }
  }

  updateStockIndicator(doc) {
    const oldStockIndicator = document.querySelector(".stock-indicator");

    if (!oldStockIndicator) {
      return;
    }

    const newStockIndicator = doc.querySelector(".stock-indicator");
    oldStockIndicator.parentNode.replaceChild(newStockIndicator, oldStockIndicator);
  }

  updateStockPrice(doc) {
    const oldStockPrice = document.querySelector(".add-to-cart");

    if (!oldStockPrice) {
      return;
    }

    const newStockPrice = doc.querySelector(".add-to-cart");
    oldStockPrice.parentNode.replaceChild(newStockPrice, oldStockPrice);
  }
}

if (!window.productUpdater) {
  window.productUpdater = new ProductUpdater();
}